import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.isOpen,
      "persistent": false,
      "width": "80%",
      "max-width": "1500"
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n    " + _vm._s(_vm.$i18n_t('Connectors.Connectors.create.title')) + "\n  ")];
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "disabled": !_vm.canSave
          },
          on: {
            "click": _vm.validateConnector
          }
        }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Connectors.Connectors.create.saveButton')) + "\n    ")])];
      },
      proxy: true
    }])
  }, [_c(VRow, {
    staticClass: "mt-1"
  }, [_c(VCol, {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      "data-cy": "connector_name",
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "label": _vm.$i18n_t('accMgmt.tenant.bridges.bridgeName'),
      "autocomplete": "off",
      "required": ""
    },
    model: {
      value: _vm.connector.name,
      callback: function ($$v) {
        _vm.$set(_vm.connector, "name", $$v);
      },
      expression: "connector.name"
    }
  }), _c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      "data-cy": "selected_account",
      "label": _vm.$i18n_t('accMgmt.system.tenantSelector'),
      "items": _vm.accounts,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "item-text": "name",
      "item-value": "id",
      "return-object": "",
      "required": ""
    },
    model: {
      value: _vm.selectedAccount,
      callback: function ($$v) {
        _vm.selectedAccount = $$v;
      },
      expression: "selectedAccount"
    }
  })], 1), _c(VCol, {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "data-cy": "connector_description",
      "color": _vm.color,
      "label": "Description",
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    model: {
      value: _vm.connector.description,
      callback: function ($$v) {
        _vm.$set(_vm.connector, "description", $$v);
      },
      expression: "connector.description"
    }
  }), _c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      "data-cy": "connector_type",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.bridgeTypes,
      "label": _vm.$i18n_t('accMgmt.tenant.bridges.types'),
      "item-text": "name",
      "item-value": "type",
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function () {
        return [_vm.bridgeConfigIsInbound(_vm.getBridgeTypeByType(_vm.connector.type)) ? _c(VIcon, {
          staticClass: "mr-1",
          attrs: {
            "size": "14"
          }
        }, [_vm._v("\n            fal fa-arrow-down\n          ")]) : _vm._e(), _vm.bridgeConfigIsOutbound(_vm.getBridgeTypeByType(_vm.connector.type)) ? _c(VIcon, {
          staticClass: "mr-2",
          attrs: {
            "size": "14"
          }
        }, [_vm._v("\n            fal fa-arrow-up\n          ")]) : _vm._e(), _vm._v("\n          " + _vm._s(_vm.getBridgeTypeName(_vm.connector.type)) + "\n        ")];
      },
      proxy: true
    }, {
      key: "item",
      fn: function (data) {
        return [_c(VListItemAvatar, [_vm.bridgeConfigIsInbound(data.item) ? [_c(VIcon, {
          staticClass: "mr-0",
          attrs: {
            "size": "14"
          }
        }, [_vm._v("fal fa-arrow-down")])] : _vm._e(), _vm.bridgeConfigIsOutbound(data.item) ? [_c(VIcon, {
          staticClass: "mr-0",
          attrs: {
            "size": "14"
          }
        }, [_vm._v("fal fa-arrow-up")])] : _vm._e()], 2), _c(VListItemContent, [_c(VListItemTitle, {
          domProps: {
            "innerHTML": _vm._s(data.item.name || data.item.type)
          }
        })], 1)];
      }
    }]),
    model: {
      value: _vm.connector.type,
      callback: function ($$v) {
        _vm.$set(_vm.connector, "type", $$v);
      },
      expression: "connector.type"
    }
  })], 1)], 1), _vm.connector.type ? [_c('h4', [_vm._v(_vm._s(_vm.$i18n_t('Connectors.Connectors.create.connectorData')))]), _vm.hasQuickReferenceContent(_vm.connector) ? _c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VExpansionPanels, {
    attrs: {
      "value": null
    }
  }, [_c(VExpansionPanel, {
    attrs: {
      "flat": ""
    }
  }, [_c(VExpansionPanelHeader, [_vm.$i18n_te(`Bridges.quickReferences.${_vm.bridgeConfig(_vm.connector).manifest.functionScope.quickReference}.title`) ? _c('div', {
    staticClass: "text-bold"
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t(`Bridges.quickReferences.${_vm.bridgeConfig(_vm.connector).manifest.functionScope.quickReference}.title`)) + "\n              ")]) : _vm._e()]), _c(VExpansionPanelContent, [_vm.$i18n_te(`Bridges.quickReferences.${_vm.bridgeConfig(_vm.connector).manifest.functionScope.quickReference}.text01`) ? _c('div', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t(`Bridges.quickReferences.${_vm.bridgeConfig(_vm.connector).manifest.functionScope.quickReference}.text01`))
    }
  }), _c('br')]) : _vm._e(), _vm.$i18n_te(`Bridges.quickReferences.${_vm.bridgeConfig(_vm.connector).manifest.functionScope.quickReference}.text02`) ? _c('div', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t(`Bridges.quickReferences.${_vm.bridgeConfig(_vm.connector).manifest.functionScope.quickReference}.text02`))
    }
  }), _c('br')]) : _vm._e(), _vm.$i18n_te(`Bridges.quickReferences.${_vm.bridgeConfig(_vm.connector).manifest.functionScope.quickReference}.text03`) ? _c('div', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t(`Bridges.quickReferences.${_vm.bridgeConfig(_vm.connector).manifest.functionScope.quickReference}.text03`))
    }
  })]) : _vm._e()])], 1)], 1)], 1)], 1) : _vm._e(), _c(VRow, {
    staticClass: "py-2",
    staticStyle: {
      "min-width": "0"
    }
  }, [_vm._l(_vm.bridgeConfigKeys(_vm.connector), function (configKey, j) {
    return _c(VCol, {
      key: `bridge_config_item_${j}`,
      staticClass: "py-2",
      attrs: {
        "cols": "12",
        "sm": 12,
        "md": _vm.getColumnSize('md', configKey, _vm.bridgeConfig(_vm.connector).manifest),
        "lg": _vm.getColumnSize('lg', configKey, _vm.bridgeConfig(_vm.connector).manifest),
        "xl": _vm.getColumnSize('xl', configKey, _vm.bridgeConfig(_vm.connector).manifest)
      }
    }, [_c('core-tenant-bridge-config-field', {
      attrs: {
        "data-cy": "bridge_config",
        "fieldConfig": _vm.bridgeConfig(_vm.connector).manifest.config[0][configKey],
        "bridgeConfig": _vm.connector.bridge.config,
        "bridgeConfigId": _vm.connector.id,
        "bridgeType": _vm.connector.type,
        "configKey": configKey,
        "bridgeManifest": _vm.bridgeConfig(_vm.connector).manifest,
        "bridgeHasValidParameters": _vm.bridgeHasValidParameters(),
        "bridgeHasValidParametersStrict": _vm.bridgeHasValidParameters(true),
        "brigdeHasError": _vm.connector.hasError
      },
      on: {
        "changedBridgeParams": _vm.changedBridgeParams
      },
      model: {
        value: _vm.connector.bridge.config[configKey],
        callback: function ($$v) {
          _vm.$set(_vm.connector.bridge.config, configKey, $$v);
        },
        expression: "connector.bridge.config[configKey]"
      }
    })], 1);
  }), _vm.shouldShowTemplateSelect(_vm.connector) ? _c(VCol, {
    staticClass: "py-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "3"
    }
  }, [_c(VSelect, {
    attrs: {
      "data-cy": "parser_script",
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "items": _vm.validTemplates(_vm.bridgeConfig(_vm.connector).manifest.templates),
      "label": _vm.$i18n_t('accMgmt.tenant.bridges.bridgeTemplate'),
      "disabled": _vm.connector.bridge.mutator !== undefined,
      "readonly": _vm.connector.bridge.mutator !== undefined || _vm.validTemplates(_vm.bridgeConfig(_vm.connector).manifest.templates).length <= 1,
      "item-text": "name",
      "item-value": "name",
      "hide-details": "auto",
      "required": ""
    },
    scopedSlots: _vm._u([_vm.bridgeConfig(_vm.connector).manifest.functionScope.editableMutator ? {
      key: "append-outer",
      fn: function () {
        return [_c(VBtn, {
          class: 'v-btn-x v-btn--rounded bg-rounded-button-' + _vm.color,
          attrs: {
            "data-cy": "edit_config_mutator",
            "color": _vm.color,
            "icon": "",
            "info": "",
            "fab": "",
            "text": ""
          },
          on: {
            "click": function ($event) {
              return _vm.editConfigMutator(_vm.connector, _vm.i);
            }
          }
        }, [_c(VIcon, {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("fal fa-" + _vm._s(_vm.connector.bridge.mutator ? 'undo' : 'edit'))])], 1)];
      },
      proxy: true
    } : null], null, true),
    model: {
      value: _vm.connector.config.parser.script,
      callback: function ($$v) {
        _vm.$set(_vm.connector.config.parser, "script", $$v);
      },
      expression: "connector.config.parser.script"
    }
  })], 1) : _vm._e(), _vm.connector.bridge.mutator ? _c(VCol, {
    staticClass: "py-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('codemirror', {
    ref: "codemirror",
    staticClass: "elevation-3",
    style: `border: 1px solid ${!_vm.bridgeHasValidParameters() ? 'red' : 'transparent'}`,
    attrs: {
      "data-cy": "bridge_mutator",
      "options": _vm.cmOptions
    },
    on: {
      "focus": _vm.onCmFocus
    },
    model: {
      value: _vm.connector.bridge.mutator,
      callback: function ($$v) {
        _vm.$set(_vm.connector.bridge, "mutator", $$v);
      },
      expression: "connector.bridge.mutator"
    }
  })], 1) : _vm._e()], 2)] : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };